import React, { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from "react";
import RdContext from "../../contexts/RdProvider";
import { ICompanyModel } from "../../models/DTO/CompanyModel";
import { DropdownType, RdContextType } from "../../@types/Rd";
import { Form, Container } from "react-bootstrap";
import "./Styles.scss"
import { GetCompaniesOptions, GetDefaultOption } from "../../Helpers/helper";
import { MessageRequired, MessageValid } from "../../Validations/Common";
import { IUserModel } from "../../models/DTO/UserModel";
import { Location, NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import ApiErrorContext, { ApiErrorContextType } from "../../contexts/ApiErrorProvider";
import { IErrorModel } from "../../models/DTO/ErrorModel";

type ContextSetProps = {
    UpdateCurrentCompany?: Dispatch<SetStateAction<ICompanyModel | undefined>>,
    UpdateRdToken?: Dispatch<SetStateAction<string | undefined>>,
    UpdateUserInfo?: Dispatch<SetStateAction<IUserModel | undefined>>
}

type ActionSetProps = ContextSetProps & {
    setIsValid: Dispatch<SetStateAction<boolean>>,
    setMsgError: Dispatch<SetStateAction<string>>,
    navigate: NavigateFunction,
    location?: Location
    UpdateErrorState?: (error?: IErrorModel) => void,
    ResetMasterActivity: () => void
}

const Validate = (value?: string, company?: ICompanyModel): string[] => {
    const validations: string[] = [];

    if (value == null || value == "")
        validations.push(MessageRequired);

    if (value != "" && value == GetDefaultOption().Caption)
        validations.push("Opção inválida.");

    if (value != "" && company == null)
        validations.push("Não foi possivel Identificar a empresa.");

    return validations;
}

const handlePick = (value: string | undefined, companies: ICompanyModel[] | undefined, actionSet: ActionSetProps): void => {
    const company = companies?.find(x => x && x.Id > 0 && x.Id.toString() == value),
        validations: string[] = Validate(value, company);

    if (validations.some(z => z)) {
        actionSet.setMsgError(validations.join("\n"));
        actionSet.setIsValid(false);
    }
    else {
        actionSet.ResetMasterActivity();
        actionSet.UpdateErrorState && actionSet.UpdateErrorState(undefined);
        actionSet.UpdateRdToken && actionSet.UpdateRdToken("");
        actionSet.UpdateCurrentCompany && actionSet.UpdateCurrentCompany(company!)
        actionSet.UpdateUserInfo;
        actionSet.setIsValid(true);

        if (actionSet?.location?.pathname != null && !actionSet.location.pathname.includes("/Home"))
            actionSet.navigate != null && actionSet.navigate("/Home", { replace: true });

    }
}

const CompanySelection = ({ removeFeedback }: { removeFeedback?: true | boolean }): JSX.Element => {

    const { Companies, currentCompany, UpdateCurrentCompany, UpdateRdToken, UpdateUserInfo, ResetMasterActivity } = useContext<RdContextType>(RdContext),
        { UpdateErrorState } = useContext<ApiErrorContextType>(ApiErrorContext),
        [selections, SetSelections] = useState<DropdownType[]>([GetDefaultOption()]),
        [pickedValue, setPickedValue] = useState<number | undefined>(currentCompany?.Id),

        cmbCompanySelectionRef = useRef<HTMLSelectElement>(null),
        cmbCompanySelection: HTMLSelectElement | null = cmbCompanySelectionRef.current,

        [isValid, setIsValid] = useState<boolean>(false),
        [msgOk, setMsgOk] = useState<string>(MessageValid),
        [msgError, setMsgError] = useState<string>(MessageRequired),
        navigate = useNavigate(),
        location = useLocation(),
        actionSet: ActionSetProps | undefined = { setIsValid, setMsgError, UpdateCurrentCompany, UpdateRdToken, UpdateUserInfo, navigate, location, UpdateErrorState, ResetMasterActivity };


    useEffect(() => {
        if (Companies != null && Companies.some(x => x)) {
            const filtered = Companies
                .filter(x => x && x.IsActive && x.Name != null && x.Name != "" && x.Id > 0);

            SetSelections(GetCompaniesOptions(filtered));
        }
    }, [Companies]);

    useEffect(() => setPickedValue(currentCompany?.Id), [currentCompany]);

    useEffect(() => setIsValid(!Validate(pickedValue as any, currentCompany).some(x => x)), [pickedValue]);

    return (
        <Container id="CompanySelectionArea" fluid className="fullWidth">
            <Form.Group controlId="CompanySelectionValidation" className="fullWidth">
                <Form.FloatingLabel
                    controlId="cmbCompanySelection"
                    label="Empresa:">
                    <Form.Select
                        ref={cmbCompanySelectionRef}
                        isValid={isValid}
                        isInvalid={!isValid}
                        as="select"
                        required
                        aria-label="Seleção de Empresa"
                        aria-required
                        value={pickedValue}
                        onChange={(event) => handlePick(cmbCompanySelection?.value, Companies, actionSet)}
                    >
                        {
                            selections
                                .map((opt, i) => <option
                                    key={`opt-CompanySelection-${i}`}
                                    value={opt.Value}>{opt.Caption}</option>)
                        }
                    </Form.Select>
                    {!removeFeedback && isValid && <Form.Control.Feedback type="valid" >{msgOk}</Form.Control.Feedback>}
                    {!removeFeedback && !isValid && <Form.Control.Feedback type="invalid">{msgError}</Form.Control.Feedback>}
                </Form.FloatingLabel>
            </Form.Group>
        </Container>
    )

}

export default CompanySelection;